import Validate from '../Validate.js';

export class TabBar {
    /**
     * @param {HTMLElement} parent
     * @param {Tab[]} tabs
     */
    constructor(parent, tabs) {
        Validate.assertIsValue(parent);
        Validate.assertIsValue(tabs);
        let div = document.createElement('div');
        div.classList.add("tab-scroller__scroll-content");
        this._root = parent.appendChild(div);
        this._tabs = tabs;
        for (const tab of tabs) {
            tab.render(this._root)
            tab.onClick(this._tabClicked.bind(this, tab))
        }
        this._tabClickCb = (tabIndex) => {/*noop*/};
        this._activeTabIndex = 0;
    }

    onTabClick(cb) {
        this._tabClickCb = cb;
    }

    setActiveTab(tabIndex) {
        this._activeTabIndex = tabIndex;
        for (let i = 0; i < this._tabs.length; i++) {
            this._tabs[i].activated(i === tabIndex)
        }
    }

    getActiveTabIndex() {
        return this._activeTabIndex;
    }

    _tabClicked(tab) {
        const index = this._tabs.findIndex(o => o === tab);
        this._tabClickCb(index);
    }
}

export class Tab {
    /** @param {string} name */
    constructor(name) {
        /**
         * @type {string}
         * @private
         */
        this._name = name;
        /**
         * @type {HTMLElement}
         * @private
         */
        this._root = null;
    }

    activated(isActive) {
        if (isActive) {
            this._root.classList.add('tab--active')
            this._root.getElementsByClassName('tab-indicator')[0].classList.add('tab-indicator--active')
        } else {
            this._root.classList.remove('tab--active')
            this._root.getElementsByClassName('tab-indicator')[0].classList.remove('tab-indicator--active')
        }
    }

    /** @param {HTMLElement} parent */
    render(parent) {
        let btn = document.createElement('button');
        btn.classList.add("tab");
        btn.innerHTML = Tab.htmlTemplate(this._name);
        this._root = parent.appendChild(btn);
    }

    onClick(cb) {
        this._root.addEventListener('click', cb)
    }

    static htmlTemplate(name) {
        return `<span class="tab__content">
                    <span class="tab__text-label">${name}</span>
                  </span>
                  <span class="tab-indicator">
                    <span class="tab-indicator__content tab-indicator__content--underline"></span>
                  </span>
                <span class="tab__ripple"></span>`
    }
}
